<div class="mb-4">
  <h3 class="color-theme font-weight-bold mb-0">
    {{ "Impostazioni valute" | translate }}
  </h3>
</div>
<div class="currency-container">
  <div class="card">
    <div class="card-body">
      <table class="table manage-table">
        <thead>
          <tr>
            <th scope="col" class="col-languages">
              {{ "Valuta" | translate }}
            </th>
            <th scope="col" class="col-languages">
              {{ "Simbolo" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of allCurrencies">
            <td>{{ element.currency }}</td>
            <td>{{ element.symbol }}</td>
            <td
              style="
                border-right: 1px solid rgba(0, 0, 0, 0.125);
                border-bottom: 1px solid rgba(0, 0, 0, 0.125);
                padding: 0;
                width: 10%;
              "
            >
              <div
                class="deleteImg"
                data-toggle="modal"
                data-target="#delCurrencyModal"
                (click)="setCurrencyToDelete(element)"
              >
                <img
                  src="assets/img/Pittogramma elimina - cestino.png"
                  style="width: 30px"
                  alt=""
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="manage-toolbar">
        <button
          class="pl-4 pr-4 mt-2 btn btn-secondary"
          data-toggle="modal"
          data-target="#currencyModal"
        >
          + {{ "Aggiungi Valuta" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="currencyModal"
  data-backdrop="static"
  data-keyboard="false"
  tabindex="-1"
  role="dialog"
  aria-labelledby="currencyModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="currencyModalLabel">
          {{ "Aggiungi una valuta" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="language-form">
          <form>
            <div class="form-group">
              <label for="currency">{{ "Valuta" | translate }}</label>
              <input
                [(ngModel)]="newCurrency.currency"
                name="currency"
                type="text"
                class="form-control"
                id="currency"
                aria-describedby="currency"
              />
            </div>
            <div class="form-group">
              <label for="symbol">{{ "Simbolo" | translate }}</label>
              <input
                [(ngModel)]="newCurrency.symbol"
                name="symbol"
                type="text"
                class="form-control"
                id="symbol"
                aria-describedby="symbol"
              />
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ "Annulla" | translate }}
        </button>
        <button
          data-dismiss="modal"
          type="button"
          class="btn btn-primary ml-2 pl-4 pr-4"
          (click)="saveNewCurrency()"
        >
          {{ "Salva" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="delCurrencyModal"
  data-backdrop="static"
  data-keyboard="false"
  tabindex="-1"
  role="dialog"
  aria-labelledby="delCurrencyModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="delCurrencyModalLabel">
          {{ "Elimina una lingua" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{
          "Sei sicuro di voler eliminare questa valuta? Eliminare una valuta in uso da parte di account può causare problemi e errori"
            | translate
        }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ "Annulla" | translate }}
        </button>
        <button
          data-dismiss="modal"
          type="button"
          class="btn btn-primary ml-2 pl-4 pr-4"
          data-toggle="modal"
          data-target="#delConfirmCurrencyModal"
        >
          {{ "Elimina" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="delConfirmCurrencyModal"
  data-backdrop="static"
  data-keyboard="false"
  tabindex="-1"
  role="dialog"
  aria-labelledby="delConfirmCurrencyModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="delConfirmCurrencyModalLabel">
          {{ "Elimina una valuta" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{ "Sei davvero sicuro di voler eliminare questa valuta?" | translate }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ "Annulla" | translate }}
        </button>
        <button
          data-dismiss="modal"
          type="button"
          class="btn btn-primary ml-2 pl-4 pr-4"
          (click)="deleteCurrency(currencyToDelete)"
        >
          {{ "Elimina" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
